import { render, staticRenderFns } from "./resource-list.vue?vue&type=template&id=0ecaf4a9"
import script from "./resource-list.vue?vue&type=script&lang=js"
export * from "./resource-list.vue?vue&type=script&lang=js"
import style0 from "./resource-list.vue?vue&type=style&index=0&id=0ecaf4a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports